import { useTranslation } from 'react-i18next';
import { alpha, Box, Button, FormControl, Hidden, InputLabel, MenuItem, OutlinedInput, Select, Stack, Typography, useTheme } from '@mui/material';
import Container from '../../components/Container';
import DrawerComponent from '../../components/Drawer';
import { Field, Form } from 'react-final-form';
import { TextFieldCustom } from '../../components/FormElements';
import validators from '../../utils/validators';

export default function NewCommunityView(props) {
    const { t } = useTranslation();
    const { relations, defaultValues, showCommunityType} = props
    const { palette } = useTheme();

    const onBack = () => {
        props.setShowNewGroup(false)
    }
    
    const renderRoot = () => {
        return (
            <>
                <Hidden mdUp>
                    <DrawerComponent isOpen={true} onClose={() => onBack()} title={t('new_community')} headerPosition='relative' width='100%'>
                        {renderContent()}
                    </DrawerComponent>
                </Hidden>
                <Hidden mdDown>
                    <Container showProcessing={props.showLoading} message={props.message}>
                        <DrawerComponent isOpen={true} onClose={() => onBack()} maxWidth='sm' enableCloseButton title={t('new_community')} headerPosition='relative' width='100%'>
                            {renderContent()}
                        </DrawerComponent>
                    </Container>
                </Hidden>
            </>
        )
    }

    const renderContent = () => {
        return (
            <Box >
                <Form onSubmit={props.onSubmit}
                    render={({ handleSubmit }) => {
                        return (
                            <>
                            <Box sx={{ width: '100%' }}>
                                </Box>
                                <Stack>

                                    <Field
                                        name="group"
                                        component={TextFieldCustom}
                                        isEdit={true}
                                        isValid={true}
                                        label={t('community_name')}
                                        validate={validators.composeValidators(validators.required)}
                                    />

                                    <Stack direction="row" alignItems="center" justifyContent="center" sx={{position: 'absolute', bottom: '50px', left: 0, width: '100%', px: 2, zIndex: 1400 }}>
                                        <Button sx={{ color:palette.common.white }} fullWidth color='primary' variant="contained" id="next/Submit" borderRadius={'50%'} 
                                                onClick={handleSubmit}>
                                            {t('next')}
                                        </Button>
                                    </Stack>
                                </Stack>
                            </>                            
                        )
                    }}
                />
            </Box>
        )
    }

    return (
        <>{renderRoot()}</>
    )
}
